import React from "react";
import { formatPrice } from "theme/components/atoms/Typography/Price";
import { defineMessages, injectIntl } from "react-intl";
import NumberInput from "theme/components/atoms/Form/Input/NumberInput";
import OptionPicker from "../OptionPicker";
import FormItem from "theme/components/molecules/Form/Item";

const messages = defineMessages({
  bundleOptionValueLabel: {
    id: "components.organisms.Configurator.BundleOption.valueLabel",
    defaultMessage: "{label} (+{price})",
  },
  bundleOptionQuantityLabel: {
    id: "components.organisms.Configurator.BundleOption.quantityLabel",
    defaultMessage: "Quantity",
  },
});

const BundleOptionSelect = ({
  intl,
  option,
  selectedBundledProduct,
  initialQuantity,
}) => {
  return (
    <div className="bundle-option bundle-option--inline">
      <div className="bundle-option__option">
        <OptionPicker
          appearance="full"
          option={{
            name: `${option.id}.values[0]`,
            id: `${option.id}.values[0]`,
            label: option.label + (option.required ? " *" : ""),
            required: option.required,
            values: option.values
              .filter(({ prices }) => {
                return prices?.finalPrice;
              })
              .map(({ value, label, prices }) => ({
                value,
                label: intl.formatMessage(messages.bundleOptionValueLabel, {
                  label: label,
                  price: formatPrice(intl, prices.finalPrice.priceInclTax),
                }),
              })),
          }}
          selectedOption={selectedBundledProduct?.value}
        />
      </div>
      <div className="bundle-option__quantity">
        <FormItem
          label={intl.formatMessage(messages.bundleOptionQuantityLabel)}
        >
          <NumberInput
            name={`${option.id}.quantity`}
            id={`${option.id}.quantity`}
            disabled={!selectedBundledProduct?.userDefinedQuantity}
            value={
              selectedBundledProduct
                ? selectedBundledProduct.defaultQuantity
                : 0
            }
            aria-label={intl.formatMessage(messages.bundleOptionQuantityLabel)}
          />
        </FormItem>
      </div>
    </div>
  );
};

export default injectIntl(BundleOptionSelect);
